import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { ROUTES } from '@/config/routes'
import { XCircle } from 'lucide-react'

export const InviteInvalidPage = () => {
  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <XCircle className="h-5 w-5 text-destructive" />
            <CardTitle>Invalid Invitation</CardTitle>
          </div>
          <CardDescription>This invitation link is invalid or has expired</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
            The invitation link you followed is either invalid or has expired.
            Invitation links are only valid for a limited time.
            <br /><br />
            Please contact your administrator to request a new invitation.
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-2">
          <Button asChild className="w-full">
            <Link to={ROUTES.SIGNUP}>
              Create Account Without Invite
            </Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to={ROUTES.LOGIN}>
              Back to Login
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}
